import { styled } from '@mui/material/styles';

export const StyledContactMenu = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-flow: column nowrap;
    gap: ${theme.DS_spacing(['md'])};
    
    a {
      display: flex;
      align-items: center;
      gap: 12px;
      color: ${theme.DS_palette.primary.black};
    }
    svg {
      fill: ${theme.DS_palette.primary.white};
    }
    
    ${theme.breakpoints.up('lg')} {
      flex-flow: row nowrap;
    }
  `,
);
